import CONSTANT from '../../constants'
import fetchWithAuthorizationHeader from '../../helper/fetchWithAuthorizationHeader'

import type { UpdateTags } from '../../types/tags'
const { TAGS_API_URL } = CONSTANT

const updateTagsById = async (updateTags: UpdateTags): Promise<Response> => {
	const response = await fetchWithAuthorizationHeader(`${TAGS_API_URL}`, {
		method: 'PUT',
		headers: {
			'Content-Type': 'application/json',
			action: 'UPDATE'
		},
		body: JSON.stringify(updateTags)
	})

	return response
}

export default updateTagsById
